import { useCallback, useMemo, useState } from 'react';
import { useLocation, useParams } from 'react-router';
import { professionalRfpOfferPath, professionalRfpOfferPaymentPath, professionalRfpOfferConfirmPath, professionalRfpOfferCompletePath, } from '@/utils/router/links';
const stepSettings = {
    complete: {
        confirm: true,
        offer: true,
        payment: true,
    },
    confirm: {
        offer: true,
        payment: true,
    },
    offer: {},
    payment: {
        offer: true,
    },
};
/**
 * 案件提案提出ステップ関連の処理
 * @returns
 */
export const useRfpOfferStep = () => {
    const location = useLocation();
    const pathName = location.pathname;
    // 案件ID
    const { id = '' } = useParams();
    /** step の状態管理 */
    const [step, changeStep] = useState({
        complete: false,
        confirm: false,
        offer: false,
        payment: false,
    });
    /**
     * step の値を更新する
     * @param updateValues 更新する値
     */
    const changeStepValue = useCallback((updateValues) => {
        changeStep((state) => (Object.assign(Object.assign({}, state), updateValues)));
    }, []);
    /** 現在表示中のステップの key */
    const currentStepKey = useMemo(() => {
        switch (pathName) {
            case professionalRfpOfferPath(id):
                return 'offer';
            case professionalRfpOfferPaymentPath(id):
                return 'payment';
            case professionalRfpOfferConfirmPath(id):
                return 'confirm';
            case professionalRfpOfferCompletePath(id):
                return 'complete';
            default:
                return '';
        }
    }, [id, pathName]);
    /** ステップが正しいか */
    const validStep = useMemo(() => {
        if (!currentStepKey) {
            return false;
        }
        const stepSetting = stepSettings[currentStepKey];
        // ステップの条件と step の状態が全て一致するか
        return Object.keys(stepSetting).every((key) => stepSetting[key] === step[key]);
    }, [step, currentStepKey]);
    return {
        changeStepValue,
        validStep,
    };
};
